import { useState } from 'react';
import { createPortal } from 'react-dom';

function IFrame({ children, title, name, id, style }) {
  const [ref, setRef] = useState();
  const container = ref?.contentWindow?.document?.body;

  return (
    <iframe ref={setRef} title={title} name={name} id={id} style={style}>
      {container && createPortal(children, container)}
    </iframe>
  );
}

export default IFrame;
